import { render, staticRenderFns } from "./AgregarMolde.vue?vue&type=template&id=dbf4e2ba&scoped=true&"
import script from "./AgregarMolde.vue?vue&type=script&lang=js&"
export * from "./AgregarMolde.vue?vue&type=script&lang=js&"
import style0 from "./AgregarMolde.vue?vue&type=style&index=0&id=dbf4e2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf4e2ba",
  null
  
)

export default component.exports